// extracted by mini-css-extract-plugin
export var wagonCellPhotoButtonPopoverContent = "_158939900ef3ebdaedf1f42c2958e81f-css";
export var wagonCellPhotoButtonPopoverContentImage = "a5923d9ad05c87c1a2cc3cdfcc91bb8f-css";
export var cellCenterContainer = "_39996b33e604deb3fa2936bc05891235-css";